import { AfterViewInit, Component, Input, OnInit, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { AdminUIHelpers } from 'src/app/common/helpers';
import { IMultiStoreSelect } from 'src/app/common/models/multiStoreSelect';
import { FacilityManager } from 'src/app/managers/facility.manager';
import { MatCheckbox } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'multi-store-dropdown',
  templateUrl: './multi-store-dropdown.component.html',
  styleUrls: ['./multi-store-dropdown.component.scss'],
  standalone: true,
  imports: [MatCheckbox, FormsModule],
})
export class MultiStoreDropdown implements OnInit, AfterViewInit {
  @Input() public facilities: IMultiStoreSelect[] = [];
  @Input() public currentFacilityId!: string;
  @Output() public facilitiesChange = new EventEmitter<IMultiStoreSelect[]>();
  @Output() public validationCheck = new EventEmitter();
  public storesSelected = 0;
  public selectAll = false;
  public dataLoaded = false;

  constructor(private _facilityManager: FacilityManager) {}

  public ngOnInit(): void {
    if (this.facilities.length < 1) {
      this.facilities = AdminUIHelpers.getFacilitiesForMultiStore(this._facilityManager.prepFacilities());
      for (const facility of this.facilities) {
        facility.isSelected = facility.facilityId === this.currentFacilityId;
      }
      this.refreshStoresSelected();
      this.dataLoaded = true;
    } else {
      this.facilities = JSON.parse(JSON.stringify(this.facilities)) as IMultiStoreSelect[];
      this.refreshStoresSelected();
    }
  }

  public ngAfterViewInit(): void {
    /**Need a timeout here to give the multi store component
     * time to finish loading before we can scroll */
    setTimeout(() => this.attemptScroll(), 450);
  }

  private attemptScroll(): void {
    // poll async until element is available to scroll to
    if (this.dataLoaded) {
      const elementId = 'store' + this.currentFacilityId;
      document.getElementById(elementId)!.scrollIntoView({ block: 'start', behavior: 'smooth' });
    } else {
      setTimeout(() => this.attemptScroll(), 100);
    }
  }

  public refreshStoresSelected(): void {
    this.facilitiesChange.emit(this.facilities);
    this.validationCheck.emit();
    this.storesSelected = this.facilities.filter((f) => {
      return f.isSelected === true;
    }).length;

    this.selectAll = this.storesSelected === this.facilities.length ? true : false;
  }

  public selectAllStores(): void {
    this.selectAll = !!this.selectAll;
    this.facilities.forEach((ri) => {
      if (ri.facilityId !== this.currentFacilityId) {
        ri.isSelected = this.selectAll;
      }
    });
    this.refreshStoresSelected();
  }
}
